import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})

export class AppDataService {
    homeDataIsReady: boolean = false;
    registerDataIsReady: boolean = false;
    categoriesListIsReady: boolean = false;
    dataRegister: any;
    dataHome: any;
    dataHomeDistributor: any;
    calendar: boolean;
    itemsToSearch: any;
    categoriesPoints?: any = [];
    categoryEvents?: any;
    categoryOffer?: any;
}